import "../../lib/bootstrap-css";
import React from "react";
import { useState } from "react";
import Head from "next/head";
import SeoJsonLd from "../../components/jsonld/seo-jsonld";
function FormulaCard({ title, formula, resultId, children }) {
  return (
    <div className="card fluid-power-formula-card border-0 shadow-sm mb-3 mb-lg-4">
      <div className="card-body p-3 p-md-4">
        <h2 className="h6 fw-bold fluid-power-formula-card-title text-uppercase mb-1">
          {title}
        </h2>
        <p className="small text-muted mb-3 mb-md-4 font-monospace lh-sm">
          {formula}
        </p>
        <div className="fluid-power-formula-inputs d-flex flex-wrap align-items-center gap-2 gap-md-3">
          {children}
        </div>
        <div
          className="fluid-power-formula-result mt-3"
          id={resultId}
          role="status"
          aria-live="polite"
        />
      </div>
    </div>
  );
}

const inputProps = {
  type: "number",
  className: "form-control form-control-sm fluid-power-formula-input",
};

const Op = ({ children }) => (
  <span className="text-muted small fw-semibold fluid-power-formula-op">
    {children}
  </span>
);

const Formulas = () => {
  const [isPressure, setIsPressure] = useState();
  const [isArea, setIsArea] = useState();
  const [isRpm2, setIsRpm2] = useState();
  const [isDisplacement2, setIsDisplacement2] = useState();
  const [isGpm3, setIsGpm3] = useState();
  const [isPsi3, setIsPsi3] = useState();
  const [isPsi4, setIsPsi4] = useState();
  const [isArea4, setIsArea4] = useState();
  const [isHp5, setIsHp5] = useState();
  const [isRpm5, setIsRpm5] = useState();
  const [isDia6, setIsDia6] = useState();
  const [isDia12, setIsDia12] = useState();
  const [isRod12, setIsRod12] = useState();
  const [isArea7, setIsArea7] = useState();
  const [isStroke7, setIsStroke7] = useState();
  const [isGpm7, setIsGpm7] = useState();
  const [isCylSpeed8, setIsCylSpeed8] = useState();
  const [isCylForce8, setIsCylForce8] = useState();
  const [isCylArea9, setIsCylArea9] = useState();
  const [isGpm9, setIsGpm9] = useState();
  const [isErea9, setIsErea9] = useState();
  const [isStroke10, setIsStroke10] = useState();
  const [isTime10, setIsTime10] = useState();
  const [isGpm11, setIsGpm11] = useState();
  const [isArea11, setIsArea11] = useState();

  const getVariables = () => {
    const activeId = document.activeElement.id;
    const activeValue = document.activeElement.value;
    switch (activeId) {
      case "pressure1":
        setIsPressure(activeValue);
        break;
      case "area1":
        setIsArea(activeValue);
        break;
      case "rpm2":
        setIsRpm2(activeValue);
        break;
      case "displacement2":
        setIsDisplacement2(activeValue);
        break;
      case "gpm3":
        setIsGpm3(activeValue);
        break;
      case "psi3":
        setIsPsi3(activeValue);
        break;
      case "psi4":
        setIsPsi4(activeValue);
        break;
      case "area4":
        setIsArea4(activeValue);
        break;
      case "hp5":
        setIsHp5(activeValue);
        break;
      case "rpm5":
        setIsRpm5(activeValue);
        break;
      case "dia6":
        setIsDia6(activeValue);
        break;
      case "dia12":
        setIsDia12(activeValue);
        break;
      case "rod12":
        setIsRod12(activeValue);
        break;
      case "area7":
        setIsArea7(activeValue);
        break;
      case "stroke7":
        setIsStroke7(activeValue);
        break;
      case "gpm7":
        setIsGpm7(activeValue);
        break;
      case "cylSpeed8":
        setIsCylSpeed8(activeValue);
        break;
      case "cylForce8":
        setIsCylForce8(activeValue);
        break;
      case "cylArea9":
        setIsCylArea9(activeValue);
        break;
      case "gpm9":
        setIsGpm9(activeValue);
        break;
      case "erea9":
        setIsErea9(activeValue);
        break;
      case "stroke10":
        setIsStroke10(activeValue);
        break;
      case "time10":
        setIsTime10(activeValue);
        break;
      case "gpm11":
        setIsGpm11(activeValue);
        break;
      case "area11":
        setIsArea11(activeValue);
        break;
      default:
        break;
    }
  };

  function force1(pressure, area) {
    return pressure * area;
  }

  const equals = () => {
    const el = document.getElementById("forceResult");
    if (!el) return;
    const pressureValue = Number(isPressure);
    const areaValue = Number(isArea);
    const result = force1(pressureValue, areaValue);
    el.textContent = `${result} lbs`;
  };

  const c2 = 231;

  function gpm(rpm2, displacement2) {
    return (rpm2 * displacement2) / c2;
  }

  const equals2 = () => {
    const el = document.getElementById("gpmresult");
    if (!el) return;
    const rpmValue = Number(isRpm2);
    const displacementValue = Number(isDisplacement2);
    const result2 = gpm(rpmValue, displacementValue);
    el.textContent = `${result2} gpm`;
  };

  const c3 = 1714;

  function hydraulicHorsePower(gpm3, psi3) {
    return (gpm3 * psi3) / c3;
  }

  const equals3 = () => {
    const el = document.getElementById("hydHPResult");
    if (!el) return;
    const gpmValue = Number(isGpm3);
    const psiValue = Number(isPsi3);
    const hpResult = hydraulicHorsePower(gpmValue, psiValue);
    el.textContent = `${hpResult} HP`;
  };

  const c4 = 6.28;

  function torque4(psi4, area4) {
    return (psi4 * area4) / c4;
  }

  const equals4 = () => {
    const el = document.getElementById("torqueResult4");
    if (!el) return;
    const psiValue = Number(isPsi4);
    const areaValue = Number(isArea4);
    const torque4Result = torque4(psiValue, areaValue);
    el.textContent = `${torque4Result} in lbs`;
  };

  const c5 = 63025;

  function torque5(hp5, rpm5) {
    return (hp5 * c5) / rpm5;
  }

  const equals5 = () => {
    const el = document.getElementById("torqueResult5");
    if (!el) return;
    const hpValue = Number(isHp5);
    const rpmValue = Number(isRpm5);
    const torque5Result = torque5(hpValue, rpmValue);
    el.textContent = `${torque5Result} in lbs`;
  };

  const c6 = 0.7854;

  function cylArea6(dia6) {
    return Math.pow(dia6, 2) * c6;
  }

  const equals6 = () => {
    const el = document.getElementById("output6");
    if (!el) return;
    const diaValue = Number(isDia6);
    const dia6Result = cylArea6(diaValue);
    el.textContent = `${dia6Result} in²`;
  };

  const c12 = 0.7854;

  function erea12(dia12, rod12) {
    return Math.pow(dia12, 2) * c12 - Math.pow(rod12, 2) * c12;
  }

  const equals12 = () => {
    const el = document.getElementById("output12");
    if (!el) return;
    const dia12Value = Number(isDia12);
    const rod12Value = Number(isRod12);
    const erea12Result = erea12(dia12Value, rod12Value);
    el.textContent = `${erea12Result} in²`;
  };

  const c7 = 0.26;

  function cylTime7(area7, stroke7, gpm7) {
    return (area7 * stroke7 * c7) / gpm7;
  }

  const equals7 = () => {
    const el = document.getElementById("output7");
    if (!el) return;
    const areaValue = Number(isArea7);
    const strokeValue = Number(isStroke7);
    const gpmValue = Number(isGpm7);
    const cylTime7Result = cylTime7(areaValue, strokeValue, gpmValue);
    el.textContent = `${cylTime7Result} Seconds`;
  };

  const c8 = 33000;

  function cylHp8(cylSpeed8, cylForce8) {
    return (cylSpeed8 * cylForce8) / c8;
  }

  const equals8 = () => {
    const el = document.getElementById("output8");
    if (!el) return;
    const cylSpeedValue = Number(isCylSpeed8);
    const cylForceValue = Number(isCylForce8);
    const cylHp8Result = cylHp8(cylSpeedValue, cylForceValue);
    el.textContent = `${cylHp8Result} HP`;
  };

  function cylRetract9(cylArea9, gpm9, erea9) {
    return (cylArea9 * gpm9) / erea9;
  }

  const equals9 = () => {
    const el = document.getElementById("output9");
    if (!el) return;
    const cylArea9Value = Number(isCylArea9);
    const gpm9Value = Number(isGpm9);
    const erea9Value = Number(isErea9);
    const cylR9Result = cylRetract9(cylArea9Value, gpm9Value, erea9Value);
    el.textContent = `${cylR9Result} gpm`;
  };

  const c10 = 5;

  function cylSpeed10(stroke10, time10) {
    return (stroke10 * c10) / time10;
  }

  const equals10 = () => {
    const el = document.getElementById("output10");
    if (!el) return;
    const stroke10Value = Number(isStroke10);
    const time10Value = Number(isTime10);
    const cylSpeed10Result = cylSpeed10(stroke10Value, time10Value);
    el.textContent = `${cylSpeed10Result} ft/min`;
  };

  const c11 = 19.25;

  function cylSpeed11(gpm11, area11) {
    return (gpm11 * c11) / area11;
  }

  const equals11 = () => {
    const el = document.getElementById("output11");
    if (!el) return;
    const gpm11Value = Number(isGpm11);
    const area11Value = Number(isArea11);
    const cylSpeed11Result = cylSpeed11(gpm11Value, area11Value);
    el.textContent = `${cylSpeed11Result} ft/min`;
  };

  return (
    <div className="fluid-power-formulas-page container-fluid px-2 px-md-3 pb-5">
      <SeoJsonLd locale="en" pageId="formulas" />
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link
          rel="shortcut icon"
          type="image/png"
          href="/images/tu-favicon.png"
        />

        <meta
          name="facebook-domain-verification"
          content="fzctnjbrtlybvytmamk8glkng9af7p"
        />
        <title>TU - Technical Union | Fluid Power Formulas | Calculator </title>

        <meta
          name="description"
          content="Fluid Power calculator | PSI, Force, GPM, Speed, etc.. fluid power calculation at your finger tips. "
        />
        <meta name="keywords" content="TU, Fluid Power, Formulas, Calculator" />
        <meta name="author" content="Edgar Lindo" />

        <meta property="og:locale" content="en" />
        <meta property="site_name" content="TU " />

        <meta
          property="og:title"
          content=" Fluid Power Formulas Calculator"
        />
        <meta
          property="og:description"
          content="Interactive Fluid Power Formulas. Calculation of force, speed, pressure, etc, everything at your finger tips."
        />
        <meta
          property="og:image"
          content="https://www.tu.biz/oppictures/formulas.png"
        />
        <meta
          property="og:url"
          content="https://www.tu.biz/en/fluid-power-formulas"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@MrEdgarLindo" />

        <meta name="twitter:title" content=" TU  | Fluid Power Formulas " />

        <meta
          name="twitter:description"
          content="Calculation of force, pressure, speed, rpm, HP, everything you need in fluid power calculations at your finger tips."
        />
        <meta
          name="twitter:image"
          content="https://www.tu.biz/oppictures/formulas.png"
        />
      </Head>

      <header className="fluid-power-formulas-hero rounded-3 mx-auto mb-4 mb-lg-5 mt-2 mt-md-3 px-3 py-4 py-md-5 text-center">
        <div className="formulas-title mb-0">
          <h1 className="fluid-power-formulas display-6 fw-bold mb-2 mb-md-3">
            Fluid Power Formulas
          </h1>
          <p className="fluid-power-formulas-lead mx-auto mb-0 col-lg-8">
            Quick hydraulic and pneumatic reference calculators. Enter values,
            then tap equals for each result.
          </p>
        </div>
      </header>

      <div className="row g-3 g-lg-4" lang="en">
        <div className="col-lg-6">
          <FormulaCard
            title="Force"
            formula="Force (lbs) = Pressure (psi) × Area (in²)"
            resultId="forceResult"
          >
            <input
              {...inputProps}
              placeholder="Pressure (psi)"
              id="pressure1"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Area (in²)"
              id="area1"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals1"
              onClick={equals}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Pump flow (GPM)"
            formula="GPM = (rpm × Displacement in³) / 231"
            resultId="gpmresult"
          >
            <input
              {...inputProps}
              placeholder="rpm"
              id="rpm2"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Displacement (in³)"
              id="displacement2"
              onChange={getVariables}
            />
            <Op>/ 231</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals2"
              onClick={equals2}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Hydraulic horsepower"
            formula="HP = (gpm × psi) / 1,714"
            resultId="hydHPResult"
          >
            <input
              {...inputProps}
              placeholder="gpm"
              id="gpm3"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Pressure (psi)"
              id="psi3"
              onChange={getVariables}
            />
            <Op>/ 1,714</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals3"
              onClick={equals3}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Torque from pressure"
            formula="Torque (in·lb) = (psi × Area in²) / 6.28"
            resultId="torqueResult4"
          >
            <input
              {...inputProps}
              placeholder="Pressure (psi)"
              id="psi4"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Area (in²)"
              id="area4"
              onChange={getVariables}
            />
            <Op>/ 6.28</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals4"
              onClick={equals4}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Torque from power"
            formula="Torque (in·lb) = (HP × 63,025) / rpm"
            resultId="torqueResult5"
          >
            <input
              {...inputProps}
              placeholder="HP"
              id="hp5"
              onChange={getVariables}
            />
            <Op>× 63,025 /</Op>
            <input
              {...inputProps}
              placeholder="rpm"
              id="rpm5"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals5"
              onClick={equals5}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Cylinder area"
            formula="Area (in²) = Diameter² × 0.7854"
            resultId="output6"
          >
            <input
              {...inputProps}
              placeholder="Diameter (in)"
              id="dia6"
              onChange={getVariables}
            />
            <Op>² × 0.7854</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals6"
              onClick={equals6}
            >
              =
            </button>
          </FormulaCard>
        </div>

        <div className="col-lg-6">
          <FormulaCard
            title="EREA (rod end area)"
            formula="EREA (in²) = (Bore² × 0.7854) − (Rod² × 0.7854)"
            resultId="output12"
          >
            <input
              {...inputProps}
              placeholder="Cyl. dia. (in)"
              id="dia12"
              onChange={getVariables}
            />
            <Op>²×0.7854 −</Op>
            <input
              {...inputProps}
              placeholder="Rod dia. (in)"
              id="rod12"
              onChange={getVariables}
            />
            <Op>²×0.7854</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals12"
              onClick={equals12}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Cylinder time"
            formula="Time (s) = (Area in² × Stroke in × 0.26) / gpm"
            resultId="output7"
          >
            <input
              {...inputProps}
              placeholder="Area (in²)"
              id="area7"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Stroke (in)"
              id="stroke7"
              onChange={getVariables}
            />
            <Op>× 0.26 /</Op>
            <input
              {...inputProps}
              placeholder="gpm"
              id="gpm7"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals7"
              onClick={equals7}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Cylinder horsepower"
            formula="HP = (Cyl. speed ft/min × Cyl. force lb) / 33,000"
            resultId="output8"
          >
            <input
              {...inputProps}
              placeholder="Cyl. speed (ft/min)"
              id="cylSpeed8"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="Cyl. force (lbs)"
              id="cylForce8"
              onChange={getVariables}
            />
            <Op>/ 33,000</Op>
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals8"
              onClick={equals8}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Adjusted GPM on retract"
            formula="gpm = (Cyl. area in² × gpm) / EREA in²"
            resultId="output9"
          >
            <input
              {...inputProps}
              placeholder="Cyl. area (in²)"
              id="cylArea9"
              onChange={getVariables}
            />
            <Op>×</Op>
            <input
              {...inputProps}
              placeholder="gpm"
              id="gpm9"
              onChange={getVariables}
            />
            <Op>/</Op>
            <input
              {...inputProps}
              placeholder="EREA (in²)"
              id="erea9"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals9"
              onClick={equals9}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Cylinder speed (stroke & time)"
            formula="Speed (ft/min) = (Stroke in × 5) / Time (s)"
            resultId="output10"
          >
            <input
              {...inputProps}
              placeholder="Stroke (in)"
              id="stroke10"
              onChange={getVariables}
            />
            <Op>× 5 /</Op>
            <input
              {...inputProps}
              placeholder="Time (seconds)"
              id="time10"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals10"
              onClick={equals10}
            >
              =
            </button>
          </FormulaCard>

          <FormulaCard
            title="Cylinder speed (flow & area)"
            formula="Speed (ft/min) = (gpm × 19.25) / Cyl. area in²"
            resultId="output11"
          >
            <input
              {...inputProps}
              placeholder="gpm"
              id="gpm11"
              onChange={getVariables}
            />
            <Op>× 19.25 /</Op>
            <input
              {...inputProps}
              placeholder="Cyl. area (in²)"
              id="area11"
              onChange={getVariables}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              id="equals11"
              onClick={equals11}
            >
              =
            </button>
          </FormulaCard>
        </div>
      </div>
    </div>
  );
};

export default Formulas;
